<template>
  <div class="app-container">
    <el-card>
      <el-divider
        direction="horizontal"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff', padding: '0 5px' }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          基本信息
        </h3>
      </el-divider>
      <el-form
        ref="formRef"
        class="mt25"
        :model="formData"
        inline
        label-position="top"
      >
        <el-form-item label="选择入库申请单">
          <el-button type="primary" @click="chooseApplication"
            >申请单</el-button
          >
          <!-- <el-input disabled v-model="formData.name" style="width: 240px" /> -->
        </el-form-item>
        <el-form-item label="入库单名称">
          <el-input disabled v-model="formData.name" style="width: 240px" />
        </el-form-item>
        <el-form-item label="入库仓库">
          <el-select
            v-model="formData.inWarehouse"
            filterable
            clearable
            disabled
            placeholder="请选择入库仓库"
            style="width: 240px"
          >
            <el-option
              v-for="subItem in warehouseList"
              :key="subItem.warehouseId"
              :label="subItem.warehouseName"
              :value="subItem.warehouseId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联出库单" prop="applicationId">
          <template class="connectApplication">
            <el-tooltip
              v-if="formData.outInRecordsNames?.length > 0"
              effect="dark"
              :content="formData.outInRecordsNames"
              placement="bottom"
            >
              <el-input
                v-model="formData.outInRecordsNames"
                disabled
                clearable
                placeholder="请选择关联出库单"
                style="width: 240px"
              />
            </el-tooltip>
            <el-input
              v-else
              v-model="formData.outInRecordsNames"
              disabled
              clearable
              placeholder="请选择关联出库单"
              style="width: 240px"
            />
            <el-button
              class="ml10"
              type="primary"
              :disabled="isNull(formData.outInRecordsIds)"
              @click="handleCheck"
              >查看明细</el-button
            >
          </template>
        </el-form-item>
        <el-form-item label="备注">
          <el-input disabled v-model="formData.remarks" style="width: 240px" />
        </el-form-item>
      </el-form>
      <el-divider
        direction="horizontal"
        :style="{
          color: '#1989fa',
          borderColor: '#d0e6ff',
          marginTop: '25px',
          padding: '0 5px',
        }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          产品信息
        </h3>
      </el-divider>
      <SelectProductTable
        class="mt25"
        ref="selectProductTableRef"
        :data="selectProductTableData"
        :showConnectPro="false"
        :showDelBtn="false"
        :showAddBtn="false"
        :changeProNum="false"
        :disabledDelAndAdd="disabledDelAndAdd"
        :warehouseId="formData.inWarehouse"
        :applicationId="formData.outInRecordsId"
      />
      <el-divider
        direction="horizontal"
        border-style="dashed"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff' }"
      >
      </el-divider>
      <el-row :gutter="8" class="mt5">
        <el-col :span="1.5">
          <el-button
            type="primary"
            :disabled="saveIngFlag"
            @click="handleSubmit"
            >提交</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleSaveDraft"
            >保存草稿</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleImportDraft"
            >导入草稿</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleReset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <Dialog
      title="选择申请单"
      :modelValue="modelValue"
      width="60%"
      @onConfirm="handleConfirm"
      @onClosed="handleClosed"
    >
      <template #content>
        <Table
          :data="tableData"
          ref="tableRef"
          :columns="columns"
          maxHeight="500"
          :total="total"
          :loading="loading"
          :showFun="false"
          :isSelect="true"
          :isRadio="true"
          rowKey="applicationFormId"
          @onSearch="handleSearch"
        />
      </template>
    </Dialog>
    <el-dialog
      title="出库单明细"
      v-model="outInRecordsModel"
      width="60%"
      @close="outInRecordsHandleClosed"
    >
      <Table
        :data="outInRecordsDate"
        ref="tableRef"
        :columns="outInRecordsColumns"
        height="500px"
        :total="outInRecordsTotal"
        :loading="outInRecordsLoading"
        :showFun="false"
        :isCreateSearch="false"
        rowKey="productRecordsId"
        @onSearch="outInRecordsHandleSearch"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="outInRecordsHandleClosed">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="产品明细"
      v-model="productDialog"
      width="60%"
      @close="productHandleClosed"
    >
      <Table
        ref="productDialogTableRef"
        :showSearchIcon="false"
        :data="productDate"
        :columns="productColumns"
        :total="productTotal"
        :loading="productLoading"
        :searchAttrName="searchAttrName"
        rowKey="productRecordsId"
        tableName="applicationProduct"
        @onSearch="productHandleSearch"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="productHandleClosed">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <ImportDraft
      v-model="draftDialogOpen"
      :searchData="{ status: '1', type: '1' }"
      :columns="importDraftColumns"
      @success="handleImportDraftSuccess"
    />

    <!-- 错误数据 -->
    <ErrDataDialog :data="errTableData" title="入库失败说明" />
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, watch } from "vue";
import useCacheStore from "@/store/modules/cache";
import SelectProductTable from "@/views/warehouse/components/SelectProductTable";
import ImportDraft from "@/views/warehouse/components/ImportDraft";
import {
  inputWarehouse,
  selectProductRecordsByApplicationFormId,
} from "@/api/warehouse/outInWarehouse";
import {
  selectProductInventoryByProductRecordsId,
  selectProductRecordsByOutInRecordsId,
} from "@/api/warehouse/warehouseDate";
import { getCustomTableCols } from "@/tableColumn";
import { isNull } from "@/utils/fangerUtils";
import { errorMsg } from "@/utils/msgBox";
import Dialog from "@/components/Element/Dialog";
import Table from "@/components/Element/Table";
import { listApplicationForm } from "@/api/warehouse/applicationForm";
const { proxy } = getCurrentInstance();
const cacheStore = useCacheStore();
const warehouseList = cacheStore.warehouse;
const { getProductById, getWarehouseNameById } = cacheStore;

import ErrDataDialog from "@/views/warehouse/components/errDataDialog";
/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "returnInWarehouse",
});
const searchAttrName = ["eqptCode"];
const formRef = ref(null);
const selectProductTableRef = ref(null);
const selectProductTableData = ref([]);
const formData = ref({});
const modelValue = ref(false);
const tableData = ref([]);
const errTableData = ref([]);
const productRecords_id = ref("");
const productDialog = ref(false);
const productDialogTableRef = ref(null);
const productHandleDetail = (event, row) => {
  productRecords_id.value = row.productRecordsId;
  productDialog.value = true;
  proxy.$nextTick(() => {
    productDialogTableRef.value.onSearch();
  });
};

const columns = getCustomTableCols([
  "name",
  "applicant",
  "applicationTime",
  "applicationFormType",
  "inWarehouseName",
]);
const handleControlDisabled = (row) => {
  return row.usageType !== "1";
};

const outInRecordsDict = ref({});

const outInRecordsColumns = getCustomTableCols([
  "productName",
  {
    label: "出库单",
    prop: "outInRecordsId",
    type: "renderHtml",
    renderHtml: (row) => {
      if (row.outInRecordsId in outInRecordsDict.value) {
        return `<span>${outInRecordsDict.value[row.outInRecordsId]}</span>`;
      } else {
        return `<span>${row.outInRecordsId}</span>`;
      }
    },
  },
  "productNum",
  { label: "已出数量", prop: "completeNum" },
  { label: "未出数量", prop: "incompleteNum" },
  "recipient",
  "operateTime",
  "operatorName",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "详情",
        controlType: "success",
        controlText: true,
        controlFun: productHandleDetail,
        controlDisabled: handleControlDisabled,
      },
    ],
  },
]);
const productColumns = getCustomTableCols([
  "contractNo",
  "batchNo",
  "projectNo",
  "workContactNo",
  "projectName",
  "checkStatus",
  "returnInWarehouse",
  "firstInWarehouseTime",
  "inWarehouseTime",
  "inventoryStatus",
  "outWarehouseTime",
  "checkInventoryDisposalMode",
  "eqptCode",
  "productNum",
  "inventoryOperationType",
  "remarks",
  "operateTime",
  "operatorName",
]);
const total = ref(0);
const loading = ref(false);
const handleClosed = () => {
  modelValue.value = false;
};
const tableRef = ref(null);
const handleConfirm = () => {
  // 确认选择的申请单
  // emits("success", tableRef.value.getSelectedRows());
  const selectData = tableRef.value.getSelectedRows();
  getProductRecordsRows(selectData);
};

const outInRecordsModel = ref(false);
const outInRecordsDate = ref([]);
const outInRecordsLoading = ref(false);
const outInRecordsTotal = ref(0);
// 查看出库单明细
const handleCheck = () => {
  outInRecordsModel.value = true;
  outInRecordsHandleSearch();
};
const outInRecordsHandleSearch = () => {
  selectProductRecordsByOutInRecordsId(formData.value.outInRecordsIds).then(
    (data) => {
      const arr = [];
      data.data.forEach((item) => {
        arr.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      outInRecordsDate.value = arr;
    }
  );
};
const outInRecordsHandleClosed = () => {
  outInRecordsModel.value = false;
  outInRecordsDate.value = [];
};

const productDate = ref([]);
const productLoading = ref(false);
const productTotal = ref(0);

const productHandleClosed = () => {
  productDialog.value = false;
  productDate.value = [];
};
const productHandleSearch = () => {
  productLoading.value = true;
  selectProductInventoryByProductRecordsId({
    productRecordsId: productRecords_id.value,
  })
    .then((res) => {
      productDate.value = res.data;
      productTotal.value = res.pageParam.totleInfo || 0;
    })
    .finally((data) => {
      productLoading.value = false;
    });
};
// 选择入库申请单
const chooseApplication = () => {
  modelValue.value = true;
  handleSearch({ pageIndex: 1, pageSize: 10 });
};

const handleSearch = (data) => {
  loading.value = true;
  listApplicationForm({
    ...data,
    approvalStatus: "1",
    status: "0",
    type: "1",
    outInStatus: "1",
  })
    .then((res) => {
      res.data?.forEach((item) => {
        item.inWarehouseName = getWarehouseNameById(item.inWarehouse);
      });
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

const getProductRecordsRows = (res) => {
  if (!res) return;
  const resCopy = { ...res };
  resCopy.outInRecordsIds = resCopy.outInRecordsId;
  resCopy.outInRecordsNames = resCopy.outInRecordsName;
  delete resCopy.outInRecordsId;
  delete resCopy.outInRecordsName;
  formData.value = resCopy;
  modelValue.value = false;
  // 根据id获取产品
  selectProductRecordsByApplicationFormId(
    formData.value.applicationFormId
  ).then((data) => {
    const arr = [];
    data.data.forEach((item) => {
      item.oriIncompleteNumber = item.incompleteNum;
      item.canChange = true;
      arr.push({
        ...getProductById(item.productId),
        ...item,
      });
    });
    disabledDelAndAdd.value = true;
    selectProductTableData.value = arr;
    handleClosed();
  });
};

// 正在保存中标志，防止鼠标误点多次提交
const saveIngFlag = ref(false);
// 提交
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }

    const productData = selectProductTableRef.value.getProductData();
    if (productData === null) return;
    // if (productData.length === 0) {
    //   errorMsg("请选择产品，最少选择一个产品");
    //   return;
    // }
    formData.value.jsonData = JSON.stringify(productData);
    saveIngFlag.value = true;
    inputWarehouse({
      ...formData.value,
      completionStatus: "1",
      type: "1",
    })
      .then((res) => {
        // 重置表单
        formData.value = {};
        formRef.value.resetFields();
        selectProductTableRef.value.clearProductData();
        saveIngFlag.value = false;
      })
      .catch((res) => {
        errTableData.value = res.data;
        saveIngFlag.value = false;
      });
  });
};
// 保存草稿
const handleSaveDraft = () => {
  formRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }
    const productData = selectProductTableRef.value.getProductData(false);
    if (productData === null) return;
    formData.value.jsonData = JSON.stringify(productData);
    saveIngFlag.value = true;
    inputWarehouse({
      ...formData.value,
      completionStatus: "0",
      type: "1",
    })
      .then((res) => {
        // 重置表单
        formData.value = {};
        formRef.value.resetFields();
        selectProductTableRef.value.clearProductData();
        saveIngFlag.value = false;
      })
      .catch((res) => {
        errTableData.value = res.data;
        saveIngFlag.value = false;
      });
  });
};
// 重置
const handleReset = () => {
  disabledDelAndAdd.value = false;
  formData.value = {};
  formRef.value.resetFields();
  selectProductTableRef.value.clearProductData();
};

const draftDialogOpen = ref(false);
// 导入草稿
const handleImportDraft = () => {
  draftDialogOpen.value = true;
};
const disabledDelAndAdd = ref(false);
const handleImportDraftSuccess = (data) => {
  formData.value = data;
  const draftList = JSON.parse(data.draft);
  const reData = [];
  if (
    !isNull(draftList) &&
    draftList instanceof Array &&
    draftList.length > 0
  ) {
    draftList.forEach((item) => {
      item.oriIncompleteNumber = item.incompleteNum;
      reData.push({
        ...getProductById(item.productId),
        ...item,
      });
    });
  }
  disabledDelAndAdd.value = true;
  selectProductTableData.value = reData;
};

const importDraftColumns = getCustomTableCols([
  "name",
  "contractNo",
  "batchNo",
  "inWarehouse",
  "operateTime",
  "operatorName",
]);

onMounted(() => {
  watch(
    () => formData.value.outInRecordsIds,
    (newVal) => {
      const dict = {};
      if (!isNull(newVal)) {
        const ids = formData.value.outInRecordsIds.split(",");
        const names = formData.value?.outInRecordsNames?.split(",");
        if (ids?.length === names?.length) {
          for (let i = 0; i < ids.length; i++) {
            dict[ids[i]] = names[i];
          }
        }
      }
      outInRecordsDict.value = dict;
    },
    {
      immediate: true,
    }
  );
});
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 15px 0;
}
.connectApplication {
  display: flex;
}
</style>
